import { useQuery } from '@tanstack/react-query';
import { useToast } from 'hooks/ui';
import { getBroadcastTags } from 'api/appSettings.service';
import { BroadcastTags_queryKey } from './constants';
import { useEffect } from 'react';

type UseGetBroadcastTagsQueryOptions = {
  enabled?: boolean;
};

export const useGetBroadcastTagsQuery = ({
  enabled = true,
}: UseGetBroadcastTagsQueryOptions = {}) => {
  const toast = useToast();

  const { data, isLoading, error } = useQuery({
    queryKey: [BroadcastTags_queryKey],
    queryFn: () => getBroadcastTags(),
    enabled,
  });

  useEffect(() => {
    if (error) toast.error(error.message);
  }, [error, toast]);

  return {
    tags: data,
    isLoading,
  };
};
